<template>
  <div class="app-download">
    <h5>{{ $t("download.download-text") }}</h5>
    <div class="app-links">
      <div class="app-store-links">
        <a href="https://goldenlinkplus.net/000/g1.2.apk">
          <img
            src="../assets/GetItOnGooglePlay.png"
            alt="Google Play"
            srcset=""
          />
        </a>
        <a href="https://testflight.apple.com/join/LPHHa2CK">
          <img
            src="../assets/Download_on_the_App_Store.svg"
            alt="Apple App Store"
            srcset=""
          />
        </a>
      </div>
      <div class="app-qr">
        <p>{{ $t("download.qr-text") }}</p>
        <img src="../assets/app-qr.png" alt="App Qrcode" />
      </div>
    </div>
    <div class="referrer-code" @click="clickToCopy()">
      <span>{{ $t("download.referral-text") }}</span>
      <img src="../assets/copy.png" alt="Copy referrer code" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickToCopy() {
      navigator.clipboard.writeText("GoldMining_G");
      alert("Copied the text: " + "GoldMining_G");
    },
  },
};
</script>

<style scoped>
.app-download {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  box-sizing: border-box;
  h5 {
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 0;
    color: black;
    align-self: center;
  }
  .app-links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .app-store-links {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 1rem;
      img {
        width: 90%;
        margin: 0;
      }
    }
    .app-qr {
      width: 80%;
      p {
        font-size: 0.8rem;
        color: black;
      }
      img {
        width: auto;
        margin: 0 auto;
      }
    }
  }
  .referrer-code {
    color: #3daec9;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    span {
      border: 1px solid #3daec9;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
    }
    img {
      display: none;
    }
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .app-download {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0;
    padding-right: 1rem;
    box-sizing: border-box;
    h5 {
      font-weight: bold;
      font-size: 1.2rem;
      margin-top: 0;
      color: black;
      align-self: center;
    }
    .app-links {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      text-align: start;
      .app-store-links {
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        img {
          width: 90%;
        }
      }
      .app-qr {
        width: 40%;
        p {
          font-size: 0.8rem;
          color: black;
        }
        img {
          margin: 0;
        }
      }
    }
    .referrer-code {
      color: #3daec9;
      font-size: 1.2rem;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 1rem;
      span {
        border: 1px solid #3daec9;
        padding: 0.5rem 1rem;
        border-radius: 0.5rem;
        margin-right: 1rem;
      }
      img {
        display: block;
        width: auto;
        margin: 0;
      }
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
